window.V2Dialog = {
  open(id) {
    const d = document.getElementById(id); if (!d) return;
    // Preserve the page scroll: showModal() + the overflow-hidden scroll-lock
    // can otherwise nudge the document to the top on open in some browsers.
    this._scrollY = window.scrollY;
    d.showModal();
    document.documentElement.classList.add('v2-scroll-lock');
    window.scrollTo(0, this._scrollY);
  },
  close(id) { const d = document.getElementById(id); if (!d) return; d.close(); }
};
document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-v2-dialog-open]');
  if (opener) { e.preventDefault(); window.V2Dialog.open(opener.dataset.v2DialogOpen); return; }
  const closer = e.target.closest('[data-v2-dialog-close]');
  if (closer) { closer.closest('dialog')?.close(); return; }
  const dlg = e.target.closest('dialog.v2-dialog');
  if (dlg && e.target === dlg) dlg.close(); // backdrop click
});
document.addEventListener('close', (e) => {
  if (e.target.matches?.('dialog.v2-dialog')) {
    document.documentElement.classList.remove('v2-scroll-lock');
    if (typeof window.V2Dialog._scrollY === 'number') window.scrollTo(0, window.V2Dialog._scrollY);
  }
}, true);

// Mobile swipe-down-to-close for drawer dialogs (bottom sheets). Only engages
// when the drawer's own scroll is at the top, so it doesn't fight content
// scrolling; drags the sheet with the finger and closes past a threshold.
(() => {
  let startY = 0, dy = 0, dlg = null;
  document.addEventListener('touchstart', (e) => {
    const d = e.target.closest('dialog.v2-dialog--drawer');
    if (!d || d.scrollTop > 0) { dlg = null; return; }
    dlg = d; startY = e.touches[0].clientY; dy = 0;
  }, { passive: true });
  document.addEventListener('touchmove', (e) => {
    if (!dlg) return;
    if (dlg.scrollTop > 0) { dlg.style.transform = ''; dlg = null; return; }
    dy = e.touches[0].clientY - startY;
    dlg.style.transform = dy > 0 ? `translateY(${dy}px)` : '';
  }, { passive: true });
  document.addEventListener('touchend', () => {
    if (!dlg) return;
    const d = dlg; dlg = null;
    d.style.transform = '';
    if (dy > 100) d.close();
  }, { passive: true });
})();
